(function () {
  availabilityCalendar.$inject = ["API_URL", "$http", "CalendarService", "$rootScope", "$location"];
  angular.module('calendarApp').directive('availabilityCalendar', availabilityCalendar);

  function availabilityCalendar(API_URL, $http, CalendarService, $rootScope, $location) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/availability-calendar.html',
      scope: {
        serviceid: '='
      },
      link: function link(scope, elem, attrs) {
        scope.daysAvailable = []; // Delete any params

        var init = function init() {
          $http.get(API_URL + '/api/v1/daysavailable/' + smooth.orgid + '?getwaitlists=true&serviceid=' + scope.serviceid).then(function (reply) {
            var response = reply.data;

            if (!response.success) {
              console.error(response.msg);
              return;
            }

            if (!response.days.length) {
              scope.noAvailability = true;
            } else {
              scope.month = moment().month();
              scope.year = moment().year();
              scope.daysAvailable = response.days;
              scope.waitlistDays = response.dayswithwaitlists ? response.dayswithwaitlists.filter(function (day) {
                if (day.date && day.canwaitlist) {
                  return day.date;
                }
              }) : [];
              displayDays();
            }

            $(elem).fadeIn('slow');
          }).catch(function (err) {
            console.error(err.message);
          });
        }; // Called when the calendar is first instantiated


        init(); // Only interested in days available for this month

        function displayDays() {
          var monthObject = CalendarService.getMonthGrid(scope.month, scope.year, scope.daysAvailable, scope.waitlistDays); // Determine whether to show next / previous months
          // - If none of the daysAvailable lie in the previous month don't show previous
          // - If none of the daysAvailable lie in the next month don't show next

          scope.showPrevious = false;
          scope.showNext = false;

          if (moment(scope.daysAvailable[0]).isBefore(moment().day(1).month(scope.month).year(scope.year))) {
            scope.showPrevious = true;
          }

          if (moment(scope.daysAvailable[scope.daysAvailable.length - 1]).isAfter(moment().month(scope.month).year(scope.year).endOf('month'))) {
            scope.showNext = true;
          }

          scope.rows = new Array(Math.floor(monthObject.dates.length / 7));
          scope.columns = new Array(7);
          scope.monthName = monthObject.month.name;
          scope.dates = monthObject.dates;
          scope.days = monthObject.days;
        }

        scope.showNextMonth = function () {
          var newMonth = moment().day(1).month(scope.month).year(scope.year).add(1, 'months');
          scope.month = newMonth.month();
          scope.year = newMonth.year();
          displayDays();
        };

        scope.showPreviousMonth = function () {
          var newMonth = moment().day(1).month(scope.month).year(scope.year).subtract(1, 'months');
          scope.month = newMonth.month();
          scope.year = newMonth.year();
          displayDays();
        };

        scope.chooseDate = function (serviceID, date) {
          // Must log the user in if they are not already.
          if (!$rootScope.customerInfo) {
            $location.search({
              serviceid: serviceID,
              date: date
            });
            return $location.path('/login');
          }

          $location.path('service-availability/' + serviceID + '/' + date);
        };
      }
    };
  }
})();